import type { SVGProps } from "react";
export interface CoinsExchangeCurrencyIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CoinsExchangeCurrencyIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CoinsExchangeCurrencyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 16a4.875 4.875 0 1 0-9.751 0 4.875 4.875 0 0 0 9.75 0Zm-4.956 1.296a.2.2 0 0 0 .082.016.2.2 0 0 0 .07-.012.2.2 0 0 0 .046-.026q.01-.011.007-.007-.001.006.002-.017-.001-.012-.002-.014v-.002l-.004-.007-.02-.022a.7.7 0 0 0-.34-.157c-.936-.205-2.087-.878-2.135-2.302v-.039c0-.923.534-1.67 1.304-2.033.14-.461.563-.8 1.07-.8.509 0 .933.34 1.073.802q.177.084.335.196l.16.123.085.078a1.12 1.12 0 0 1-1.085 1.87c.885.296 1.808 1.037 1.808 2.307 0 .993-.575 1.703-1.299 2.057a1.12 1.12 0 0 1-1.077.818 1.12 1.12 0 0 1-1.075-.814 2.6 2.6 0 0 1-.73-.538l.818-.773.818-.773a.3.3 0 0 0 .089.069m-1.679-.114a1.125 1.125 0 0 1 1.59.045l-1.637 1.546a1.126 1.126 0 0 1 .047-1.591m1.654-2.479h-.003c.038.034.141.102.35.148q.105.023.214.056a1 1 0 0 1-.243-.12l-.092-.07-.031-.017a.3.3 0 0 0-.088-.013c-.054 0-.09.01-.107.016M.875 8a7.125 7.125 0 0 1 13.86-2.328l.09.273.026.113a1.125 1.125 0 0 1-2.143.644l-.038-.108-.129-.37A4.877 4.877 0 0 0 3.125 8a4.88 4.88 0 0 0 3.098 4.541l.37.129.11.038a1.125 1.125 0 0 1-.645 2.143l-.113-.026-.273-.09A7.13 7.13 0 0 1 .875 8m7.48-3.625c.53 0 1.034.117 1.488.328l.19.095.098.06a1.124 1.124 0 0 1-1.06 1.97l-.104-.05-.142-.064a1.29 1.29 0 0 0-1.244.168 1.125 1.125 0 0 1 .002 2.234c.128.095.27.17.424.213a1.125 1.125 0 1 1-.603 2.166 3.6 3.6 0 0 1-2.452-2.373 1.123 1.123 0 0 1 0-2.246c.465-1.442 1.8-2.501 3.402-2.501Zm14.77 11.624a7.125 7.125 0 1 1-14.25 0 7.125 7.125 0 0 1 14.25 0M1.57 14.96c.42-.173.904-.078 1.225.244l2 2.001.078.085a1.126 1.126 0 0 1-1.625 1.545A2.88 2.88 0 0 0 6 20.875h2l.116.005a1.126 1.126 0 0 1 0 2.239L8 23.125H6A5.125 5.125 0 0 1 .875 18v-2c0-.455.274-.865.694-1.04ZM18 .876A5.125 5.125 0 0 1 23.125 6v2a1.126 1.126 0 0 1-1.92.795l-2-2-.078-.086a1.125 1.125 0 0 1 1.623-1.546A2.875 2.875 0 0 0 18 3.125h-2a1.125 1.125 0 0 1 0-2.25h2Z"
      />
    </svg>
  );
}
